import { createDecorator } from '../../instantiation/common/instantiation.js';
const IQuickInputService = ( createDecorator('quickInputService'));
export { IQuickInputService };
